'use strict';

import ngResource from 'angular-resource';

class AnnounceService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/announce/:id',
            {id: '@id'},
            {
                index : { method: 'GET', isArray: true },
                show : { method: 'GET'}
            }
        )

        this.oem_api = $resource(
            '/api/oem/announce/:id',
            {id: '@id'},
            {
                index : { method: 'GET', isArray: true },
                show : { method: 'GET'}
            }
        )
    }
}

export default angular.module('leptinApp.AnnounceService', ['ngResource'])
    .service('AnnounceService', ['$resource', AnnounceService])
    .name



// WEBPACK FOOTER //
// ./public/dev/components/api/announce/announce.service.js